import type { CorrelationWidgetKind } from "../../../widgets/correlation/correlationWidgetTypes";

/** Encode curve id for URL path (preserve colons for Axum). */
export function encodeCurveIdForPath(id: string): string {
  return encodeURIComponent(id).replace(/%3A/gi, ":");
}

export type VolCoreWidgetKind =
  | "vol-surface-3d"
  | "vol-term"
  | "vol-skew"
  | "vol-calibration"
  | "vol-controls"
  | "vol-binding";

export type VolWidgetKind = VolCoreWidgetKind | CorrelationWidgetKind;

export type VolWidgetInstance = {
  id: string;
  kind: VolWidgetKind;
  x: number;
  y: number;
  w: number;
  h: number;
  config?: Record<string, unknown>;
};

export type VolWorkspaceTab = {
  id: string;
  name: string;
  isDefault: boolean;
  widgets: VolWidgetInstance[];
};

export type VolWorkspaceDocument = {
  schemaVersion: number;
  currentId: string;
  workspaces: VolWorkspaceTab[];
};

export const VOL_WORKSPACE_SCHEMA_VERSION = 1;

export function persistKeyForCurve(curveId: string): string {
  return `atlas.vol-workspace.v1:${curveId}`;
}
